 /*
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

import {AbstractCrudObject} from './../abstract-crud-object';

/**
 * TargetingProductAudienceSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
export default class TargetingProductAudienceSpec extends AbstractCrudObject {
  static get Fields (): Object {
    return Object.freeze({
      exclusions: 'exclusions',
      inclusions: 'inclusions',
      product_set_id: 'product_set_id',
    });
  }

}
